import { Link } from 'react-router-dom';

export default function MenuEntrenador() {
  return (
    <nav className="bg-white shadow-md px-4 py-2 flex justify-between items-center">
      <h1 className="text-xl font-bold text-blue-600">🎓 CalisXcore</h1>

      <div className="space-x-4">
        <Link to="/galeria" className="text-gray-700 hover:text-blue-600 font-medium">
          Galería
        </Link>
        <Link to="/asignar" className="text-gray-700 hover:text-blue-600 font-medium">
          Crear Rutina
        </Link>
        <Link to="/historial" className="text-gray-700 hover:text-blue-600 font-medium">
          Historial
        </Link>
      </div>
    </nav>
  );
}
